<!--
  登录（扫码登录、账号登录）、注册账号、重置密码的弹窗，通过动态组件来显示具体的内容
  1、
 -->
<template>
  <el-dialog
    class="empty_dialog"
    :visible.sync="$_visible"
    :close-on-click-modal="false"
    :show-close="false"
    :width="currentComObje.view === 'bindForm' ? '530px' : '460px'"
    @opened="onOpened"
    @close="onClose">
    <div class="body_header">
      <span>iJournal</span>
      <span>爱期刊，专属你的期刊特区</span>
      <div class="close_icon_wrapper" @click="closeDialog">
        <i class="iconfont iconchacha"></i>
      </div>
    </div>
    <component
      v-if="$_visible"
      :is="currentComObje.view"
      @changeView="changeView"
      @closeDialog="closeDialog"
      ref="component">
    </component>
  </el-dialog>
</template>

<script>
import loginForm from './login-form'
import resetpwdForm from './resetpwd-form'
import registerForm from './register-form'
import bindForm from './bind-form'
import bindWechat from './bind-wechat'
export default {
  data () {
    return {
      // 组件及标题
      componentObj: {
        loginForm: {
          view: 'loginForm',
          title: '登 录'
        },
        resetpwdForm: {
          view: 'resetpwdForm',
          title: '忘记密码'
        },
        registerForm: {
          view: 'registerForm',
          title: '注 册'
        },
        fillinfoForm: {
          view: 'fillinfoForm',
          title: '补全信息'
        },
        bindForm: {
          view: 'bindForm',
          title: '绑定账号'
        },
        bindWechat: {
          view: 'bindWechat',
          title: '绑定微信'
        }
      }
    }
  },
  props: {
    // 控制显示
    visible: {
      type: Boolean,
      default: false
    },
    // 当前应该显示的组件
    currentComName: {
      type: String,
      default: 'loginForm'
    }
  },
  computed: {
    $_visible: {
      get () {
        return this.visible
      },
      set (newValue) {
        this.$emit('update:visible', newValue)
      }
    },
    // 当前组件对象
    currentComObje () {
      return this.componentObj[this.currentComName]
    }
  },
  components: {
    // 登录和注册的组件
    loginForm,
    // 忘记密码
    resetpwdForm,
    // 注册
    registerForm,
    // 绑定微信号
    bindWechat,   
    // 绑定账号
    bindForm
  },
  methods: {
    // 关闭当前组件
    closeDialog () {
      // 重置组件的表单
      // this.$refs.component.resetForm()
      // 关闭
      this.$_visible = false
    },
    // 切换当前组件
    changeView (viewName) {
      this.$emit('changeView', viewName)
    },

    // dialog 打开
    onOpened () {
      console.log('打开')
    },
    // dialog 关闭
    onClose () {
      console.log(this.$_visible, this.$refs.component)
      // 在绑定手机表单关闭了弹窗的话 就发送登录成功的消息
      this.currentComObje.view === 'bindForm' && this.$bus.emit('loginSuccess')
      this.currentComObje.view === 'bindWechat' && this.$bus.emit('loginSuccess')
      this.$refs.component.closeDialogCallback && this.$refs.component.closeDialogCallback()
    }
  }
}
</script>

<style lang="scss" scoped>
  .body_header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height:60px;
    background:rgba(15,164,179,1);
    & > span {
      color: #ffffff;
      &:first-child {
        font-size: 30px;
        margin-right: 12px;
      }
      &:last-child {
        font-size: 16px;
      }
    }
    .close_icon_wrapper {
      position: absolute;
      right: 15px;
      top: 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 20px;
      height: 20px;
      color: white;
      cursor: pointer;
      & > i {
        font-size: 14px;
      }
    }
  }
  .body_main {
    width: 100%;
    height: 323px;
    background-color: #ffffff;
  }
</style>

<style lang="scss">
  // 重置dialog pading
  // .el-dialog {
  //   .el-dialog__header {
  //     padding: 0;
  //   }
  //   .el-dialog__body {
  //     padding: 0;
  //   }
  //   .el-dialog__footer {
  //     padding: 0;
  //   }
  // }
</style>



// WEBPACK FOOTER //
// src/components/layout/header/form-dialog/form-dialog.vue